import { Chat } from '@components'
import { useChannel } from '@features/chat/state'
import { useParams } from '@solidjs/router'
import { type Component, createEffect, createMemo } from 'solid-js'
import { useService } from 'solid-services'
// Import useChannels to access the cached channel list
import { useChannels } from '../../../state/channels/channels'

export const List: Component = () => {
  const params = useParams()
  // 🚨 ADD setChatMode HERE
  const { setActiveChannelId, setFocusMessageId, setChatMode } = useService(useChannel)()
  const { channelsResource } = useService(useChannels)()

  const resolvedChannelId = createMemo(() => {
    const slug = params.channelId
    const channels = channelsResource()

    if (!channels) return undefined
    if (!slug) return channels.find(c => c.name === 'trade-leaders')?.id
    return channels.find(c => c.name === slug)?.id
  })

  createEffect(() => {
    setActiveChannelId(resolvedChannelId())
    setFocusMessageId(params.messageId)

    // 🚨 FIX: Automatically clear history mode when returning to the main feed
    if (!params.messageId) {
      setChatMode('latest')
    }
  })

  return (
    <>
      <Chat
        height={{
          base: 'calc(var(--vh) * 100 - 90px)',
          lgDown: 'calc(var(--vh) * 100 - 96px)',
          mdDown: 'calc(var(--vh) * 100 - 126px)',
        }}
      />
    </>
  )
}

export default List
